var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CheckSvg from './check.icon.svg';
export const CheckIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: CheckSvg }));
_react_refresh_temp_1 = CheckIcon;
$RefreshReg$(_react_refresh_temp_1, "CheckIcon");
